module.exports = __webpack_public_path__ + "img/Kibe65.ccdcfb6f.jpg";